import React from "react";
import styles from "./Transactions.module.scss";
import { FaCircleCheck } from "react-icons/fa6";
import { IoMdAlert } from "react-icons/io";
import { getLeadID } from "../../../../utils/storage";

export default function Transactions({ getTransections }) {
  const leadId = getLeadID();
  return (
    <div className={styles.transactions}>
      {getTransections.filter(item => item.leadID === leadId).map((item, index) => (
        <div className={styles.list} key={index}>
          <div className={styles.block}>
            <div className={styles.amount}>{item.amount.text}</div>
            <div className={styles.amount} style={{ color: item.amount.color }}>
              ₹{item.amount.value}
            </div>
          </div>
          <div className={styles.block}>
            <div>{item.status.text}</div>
            <div className={styles.success} style={{ color: item.status.color }}>
              {item.status.value === "Success" ? (
                <FaCircleCheck size={14} color={item.status.color} />
              ) : (
                <IoMdAlert size={16} color={item.status.color} />
              )}

              <span>{item.status.value}</span>
            </div>
          </div>
          <div className={styles.block}>
            <div>{item.createdAt.text}</div>
            <div>{item.createdAt.value}</div>
          </div>
          <div className={styles.block}>
            <div>{item.referenceNo.text}</div>
            <div>{item.referenceNo.value}</div>
          </div>
          <div className={styles.block}>
            <div>{item.mode.text}</div>
            <div>{item.mode.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
